import React from 'react'

export default function Year() {
    return new Date().getFullYear()
}
